export default import.meta.ROLLUP_FILE_URL_ShLFqVI8xue0ZXbFLAmM8g;